// Integer square root — the MBGSQRT bit ladder. game/misc.cpp:651-692.
// Determinism-critical (movement lengths, range checks). Never substitute Math.sqrt.

import { u32 } from './int32.ts';

// game/misc.cpp:656-692 `unsigned int isqrt(unsigned long val)`
// The C++ unrolls INNER_MBGSQRT(15)..(2) via macro; this loop runs the identical steps.
// All intermediates stay below 2^32 and are exact in doubles; g never exceeds 16 bits, so
// (g << s) stays a positive int32 (max 0x8000 << 15 = 2^30).
export function isqrtU32(val: number): number {
  val = u32(val);
  let g = 0;
  let temp = 0;

  if (val >= 0x40000000) {
    g = 0x8000;
    val -= 0x40000000;
  }

  for (let s = 15; s >= 2; s--) {
    temp = (g << s) + (1 << (s * 2 - 2));
    if (val >= temp) {
      g += 1 << (s - 1);
      val -= temp;
    }
  }

  temp = g + g + 1;
  if (val >= temp) g++;
  return g;
}

// game/misc.cpp:651-654 `int isqrt(int val1, int val2)` —
// (dword)val1*(dword)val1 + (dword)val2*(dword)val2 in WRAPPING unsigned 32-bit math.
export function isqrt(val1: number, val2: number): number {
  const a = u32(Math.imul(val1, val1));
  const b = u32(Math.imul(val2, val2));
  return isqrtU32(u32(a + b)) | 0;
}
